const KEY_TOKEN = "token";
const KEY_ROLE = "role";

const hasWindow = typeof window !== "undefined";
const storage = hasWindow ? window.localStorage : null;

const read = (key) => {
  if (!storage) return null;
  return storage.getItem(key);
};

const write = (key, value) => {
  if (!storage) return;
  if (value === null || value === undefined) {
    storage.removeItem(key);
  } else {
    storage.setItem(key, value);
  }
};

export const getToken = () => read(KEY_TOKEN);
export const getRole = () => read(KEY_ROLE);

export const setAuth = ({ token, role }) => {
  if (token) write(KEY_TOKEN, token);
  if (role) write(KEY_ROLE, role);
};

export const clearAuth = () => {
  write(KEY_TOKEN, null);
  write(KEY_ROLE, null);
};
